import { module } from 'modujs'
// import { lazyLoadImage } from '../utils/image'
import LocomotiveScroll from 'locomotive-scroll'
import { gsap } from '../gsap'
import { Expo } from 'gsap'
import { CUSTOM_EVENT } from '../config'

export default class extends module {
    constructor(m) {
        super(m)
    }

    init() {
        if (history.scrollRestoration) {
            history.scrollRestoration = 'manual';

            window.scrollTo(0, 0);
        }

        this.scroll = new LocomotiveScroll({
            modularInstance: this,
            scrollCallback: this.onScroll.bind(this),
            initCustomTicker: (render) => {
                gsap.ticker.add(render)
            },
            destroyCustomTicker: (render) => {
                gsap.ticker.remove(render)
            }
        })

        this.scroll.lenisInstance.on('scroll', e => {
            this.call('updateVelocity', e.velocity, 'Rail')
        })

        // Anchor links
        this.$anchors = document.querySelectorAll('a[href^="#"]')
        this.anchorEventListeners = []
        this.$anchors.forEach(($anchor, i) => {
            this.anchorEventListeners.push(e => {
                e.preventDefault()
                this.scrollTo({ target: $anchor.getAttribute('href') })
            })
            $anchor.addEventListener('click', this.anchorEventListeners[i])
        })

        // Anchor scroll on load
        const hash = window.location.hash
        if(hash) {
            this.scrollTo({
                target: hash,
                immediate: true
            })
            this.call('setReduced', true, 'Header')
        }
    }

    /**
    * On scroll
    *
    * @param {event}
    */
    onScroll(e) {

        const direction = e.direction

        if(direction !== 0) {
            this.call('setReduced', (e.scroll > 120 && direction > 0), 'Header')
        }
    }

    /**
     * Lazy load the related image.
     *
     * @see ../utils/image.js
     *
     * It is recommended to wrap your `<img>` into an element with the
     * CSS class name `.c-lazy`. The CSS class name modifier `.-lazy-loaded`
     * will be applied on both the image and the parent wrapper.
     *
     * ```html
     * <div class="c-lazy o-ratio u-4:3">
     *     <img data-scroll data-scroll-call="lazyLoad, Scroll, main" data-src="http://picsum.photos/640/480?v=1" alt="" src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==" />
     * </div>
     * ```
     *
     * @param {LocomotiveScroll} args - The Locomotive Scroll instance.
     */
    // lazyLoad(args) {
    //     lazyLoadImage(args.target, null, () => {
    //         //callback
    //     })
    // }

    scrollTo(params) {
        const { target, ...opts } = params

        const options = Object.assign({
            duration: 1,
            ease: Expo.easeInOut,
            offset: -136,
        }, opts)

        this.scroll?.scrollTo(target, options)
    }

    lock(stop=true) {
        if(stop) {
            this.scroll?.lenisInstance.stop()
        } else {
            this.scroll?.lenisInstance.start()
        }
    }

    removeScrollElements($oldContainer) {
        this.scroll?.removeScrollElements($oldContainer)
    }

    addScrollElements($newContainer) {
        this.scroll?.addScrollElements($newContainer)
    }

    update() {
        this.scroll?.update()
    }

    destroy() {
        this.scroll?.destroy()
        this.$anchors.forEach(($anchor, i) => {
            $anchor.removeEventListener('click', this.anchorEventListeners[i])
        })
    }
}
